import React from "react";
import { Box, Skeleton } from "@mui/material";

const RegionSkeleton = () => {
  return (
    <Box>
      {/* Desktop Skeleton */}
      <Box
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
          alignItems: "center",
          width: 150,
          height: 42,
          padding: "0 12px",
          borderRadius: "10px",
          backgroundColor: "#fff",
          border: "1px solid #E5E7EB",
          boxSizing: "border-box",
        }}
      >
        {/* Flag */}
        <Skeleton
          variant="rounded"
          width={24}
          height={16}
          sx={{
            borderRadius: "2px",
            flexShrink: 0,
          }}
        />

        {/* Text */}
        <Skeleton
          variant="text"
          width={55}
          height={20}
          sx={{
            ml: 1,
          }}
        />

        {/* Dropdown Arrow */}
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{
            ml: "auto",
          }}
        />
      </Box>

      {/* Mobile Skeleton */}
      <Box
        sx={{
          display: {
            xs: "flex",
            md: "none",
          },
          alignItems: "center",
          width: 68,
          height: 30,
          padding: "0 6px",
          borderRadius: "7px",
          backgroundColor: "#fff",
          border: "1px solid #E5E7EB",
          boxSizing: "border-box",
        }}
      >
        {/* Flag */}
        <Skeleton
          variant="rounded"
          width={20}
          height={13}
          sx={{
            borderRadius: "2px",
            flexShrink: 0,
          }}
        />

        {/* AE */}
        <Skeleton
          variant="text"
          width={20}
          height={17}
          sx={{
            ml: "5px",
          }}
        />

        {/* Dropdown Arrow */}
        <Skeleton
          variant="circular"
          width={14}
          height={14}
          sx={{
            ml: "auto",
          }}
        />
      </Box>
    </Box>
  );
};

export default RegionSkeleton;
